<template>
	<div class="col-5">
		<div class="row meta-loadshift">
			<div class="meta-period LSperiod1 left">
				<button
					type="button"
					@click.prevent="() => toggleLSPeriod('period1')"
					:class="{
						'js-btn-toggle': true,
						'cover-parent': true,
						toggled: formData.LSperiod1_bool,
					}"
					:disabled="!isEnabled"
				>
					<i class="toggle-knob"></i>
				</button>

				<div class="meta">
					<span class="label caps-sm">Period 1</span>
					<var class="range caps-xxl">
						{{formData.LSperiod1.join('&ndash;')}}
					</var>
				</div>
			</div>

			<div class="meta-period LSperiod2 right">
				<div class="meta">
					<span class="label caps-sm">Period 2</span>
					<var class="range caps-xxl">
						{{formData.LSperiod2.join('&ndash;')}}
					</var>
				</div>

				<button
					type="button"
					@click.prevent="() => toggleLSPeriod('period2')"
					:class="{
						'js-btn-toggle': true,
						'cover-parent': true,
						toggled: formData.LSperiod2_bool,
					}"
					:disabled="!isEnabled"
				>
					<i class="toggle-knob"></i>
				</button>
			</div>
		</div>

		<div class="field-wrap">
			<div ref="loadShiftSlider" id="slider_loadShift"></div>

			<div class="suffix-wrap d-flex justify-content-center">
				<p class="desc visible text-tiny bold color-blue-dark"></p>
			</div>
		</div>
	</div>
</template>

<script>
import noUiSlider from 'nouislider'
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'LSPeriods',

	props: {
		isEnabled: {
			type: Boolean,
			default: true,
		},
	},

	data: () => ({
		formData,
	}),

	mounted () {
		const {
			$refs: { loadShiftSlider },
			syncLSSlider,
			updateLSPeriodsFromSlider,
		} = this
		const { LSperiod1, LSperiod2 } = formData

		noUiSlider.create(loadShiftSlider, {
			range: { min: 0, max: 24 },
			step: 1,
			start: [...LSperiod1, ...LSperiod2],
			margin: 1,
			limit: 24,
			connect:[false, true, false, true, false],
			behaviour: 'tap-drag',
			pips: { mode: 'steps',  stepped: true, density: 8 },
			format: { to: Math.ceil, from: Math.ceil }
		})

		loadShiftSlider.noUiSlider.on('update', updateLSPeriodsFromSlider)

		syncLSSlider()
	},

	watch: {
		isEnabled (newVal) {
			if (!newVal) {
				formData.LSperiod1_bool = false
				formData.LSperiod2_bool = false
				this.syncLSSlider()
			}
		},

		'formData.LSperiod1_bool' () {
			this.syncLSSlider()
		},

		'formData.LSperiod2_bool' () {
			this.syncLSSlider()
		}
	},

	methods: {
		updateLSPeriodsFromSlider (vals) {
			const { LSperiod1_bool, LSperiod2_bool } = formData

			if (LSperiod1_bool) formData.LSperiod1 = vals.slice(0,2)
			if (LSperiod2_bool) formData.LSperiod2 = vals.slice(vals.length - 2)
		},

		toggleLSPeriod (period) {
			const { syncLSSlider } = this
			const boolKey = `LS${period}_bool`

			formData[boolKey] = !formData[boolKey]

			syncLSSlider()
		},

		// This function does some direct dom interation to facilitate the state
		// of displaying an empty slider with no ranges or points which is not
		// something that the noUiSlider api supports directly. If we decide that
		// behavior is not important we could scrap all this code and just utilize
		// the noUiSlider api as intended.
		syncLSSlider () {
			const { $refs: { loadShiftSlider } } = this
			const {
				LSperiod1,
				LSperiod1_bool,
				LSperiod2,
				LSperiod2_bool
			} = formData

			// if periods are disabled move their sliders out of the way to the sides
			const sliderValues = [
			...(LSperiod1_bool ? LSperiod1 : [0, 1]),
			...(LSperiod2_bool ? LSperiod2 : [23, 24]),
			]

			const activeNodes = []
			const inactiveNodes = []

			loadShiftSlider.querySelectorAll('.noUi-origin').forEach((n, i) => {
				if (LSperiod1_bool && i < 2 || LSperiod2_bool && i > 1) {
					activeNodes.push(n)
				} else {
					inactiveNodes.push(n)
				}
			})

			loadShiftSlider.querySelectorAll('.noUi-connect').forEach((n, i) => {
				if (LSperiod1_bool && i < 1 || LSperiod2_bool && i > 0) {
					activeNodes.push(n)
				} else {
					inactiveNodes.push(n)
				}
			})

			activeNodes.forEach(n => {
				n.removeAttribute('disabled')
				n.classList.remove('hide')
			})

			inactiveNodes.forEach(n => {
				n.setAttribute('disabled', true)
				n.classList.add('hide')
			})

			loadShiftSlider.noUiSlider.set(sliderValues)
		},
	}
}
</script>
